import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiService } from 'src/app/api.service';
import { CategoryLan } from 'src/app/shared/models/CategoryLan';
import { PeriodsVO } from 'src/app/shared/models/PeriodsVO';
import { PurchasingSum } from 'src/app/shared/models/PurchasingSum';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import { TranslateRelLabelVO } from 'src/app/shared/models/TranslateRelLabelVO';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';

@Component({
  selector: 'app-purchasing-sum',
  templateUrl: './purchasing-sum.component.html',
  styleUrls: ['./purchasing-sum.component.scss',],
  providers: [MessageService, ConfirmationService]
})
export class PurchasingSumComponent implements OnInit {
  token: string;
  security: SecurityDocument;
  listYears: PeriodsVO[];
  selectedYearVO: PeriodsVO;
  blocked: boolean = false;
  listPurchasingSum: PurchasingSum[];
  selectedStore: string;
  selectedYear: string;
  backToStoreId: string;

  listStatus: CategoryLan[];
  selectedStatus: CategoryLan;
  status:string;

  lstRespTranslate: TranslateRelLabelVO[];
  lbl_zone: string = "zone_";
  lbl_year: string = "year_";
  lbl_select: string = "select_";
  lbl_search: string = "search_";
  lbl_total: string = "total_";
  lbl_status: string = "status_";
  lbl_back: string = "back_";
  lbl_guides: string = "guides_";
  lbl_summary: string = "summary_";
  lbl_coordination: string = "coordination_";
  lbl_coordinations: string = "coordinations_";




  constructor(
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    public datepipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router,
    private tovpilUtils: TovpilUtilsService) {
  }

  ngOnInit(): void {

    this.route.queryParams
      .subscribe(
        params => {
          this.token = params.token;
          this.backToStoreId = params.backToStoreId;
          this.selectedStore = params.selectedStore;
          this.selectedYear = params.selectedYear;
          this.status = params.status;
        });
    this.getSecurity();

  }
  getSecurity() {

    this.apiService.findSecurityById({ "id": this.token }).then(
      data => {
        this.security = data;
        if (!this.selectedStore) {
          this.selectedStore = this.security.storeId;
        }
        this.getTranslatedLabels();
        this.getValidPeriods();
      });
  }
  getValidPeriods() {

    let sel = {} as PeriodsVO;
    this.apiService.getValidYears().then(
      data => {
        this.listYears = data;

        if (!this.selectedYear) {
          this.selectedYearVO = this.listYears[0];
           
        } else {
          sel.year = this.selectedYear;
          sel.period = null;
          sel.descrip = this.selectedYear;
          this.selectedYearVO = sel;
        }
        this.getPurchStatus();

      });
  }
  search() {
    this.blocked = true;
    this.apiService.findZoneProductionOrders({ "year": this.selectedYearVO.year, "language": this.security.language, "status": this.selectedStatus.fieldVal, "storeId": this.selectedStore }).then(
      data => {
        this.listPurchasingSum = data;
        this.blocked = false;
        this.messageService.add({ severity: 'success', summary: 'Consulta Información', detail: 'La información se cargo correctamente', life: 3000 });
      }).catch(error => {
        this.blocked = false;
        console.error(error);
      });
  }
  getTranslatedLabels() {
    let map = new Map();
    let lstCat: CategoryLan[];

    this.apiService.listByLanguageMultFields({
      'language': this.security.language,
      'region': this.security.region,
      'lstLabels': [this.lbl_select, this.lbl_year, this.lbl_search, this.lbl_total, this.lbl_zone, this.lbl_status, this.lbl_back,
      this.lbl_guides, this.lbl_summary, this.lbl_coordination, this.lbl_coordinations]
    }).then(
      trDocs => {
        this.lstRespTranslate = trDocs;

        trDocs.forEach((element) => {
          map.set(element.labelId, element.translation);
        });
        this.lbl_select = map.get(this.lbl_select);
        this.lbl_zone = map.get(this.lbl_zone);
        this.lbl_search = map.get(this.lbl_search);
        this.lbl_year = map.get(this.lbl_year);
        this.lbl_total = map.get(this.lbl_total);
        this.lbl_status = map.get(this.lbl_status);
        this.lbl_back = map.get(this.lbl_back);
        this.lbl_guides = map.get(this.lbl_guides);
        this.lbl_summary = map.get(this.lbl_summary);
        this.lbl_coordination = map.get(this.lbl_coordination);
        this.lbl_coordinations = map.get(this.lbl_coordinations);
      });
  }
  getPurchStatus() {
    this.apiService.getCategoryLang({
      'language': this.security.language,
      'fieldId': "poStatus"
    }).then(categoryLangResp => {
      this.listStatus = categoryLangResp;
      if (!this.status) {
        this.selectedStatus = this.listStatus[this.listStatus.length - 1];
        
      }else{
        this.listStatus.forEach(element => {
          if(element.fieldVal==this.status){
            this.selectedStatus=element;
            
          }
        });
      }
      this.search();
    });
  }
  redirectDetail(value: PurchasingSum) {
    this.selectedStore = value.storeId;
    let next: boolean = false;
    if (this.backToStoreId == null) {
      this.backToStoreId = this.security.storeId;
      next = true;
    } else {
      let vals = this.backToStoreId.split(",");
      if (this.selectedStore != null && vals.length < 2) {
        this.backToStoreId = this.backToStoreId + "," + this.selectedStore;
        next = true;
      } else {
        next = false;
      }
    }
    if (next) {
      this.router.navigate(['reports/zoneProductionOrders'], { queryParams: { token: this.token, selectedStore: value.storeId, selectedYear: this.selectedYearVO.year, status: this.selectedStatus.fieldVal, backToStoreId: this.backToStoreId } }).then(() => {
        window.location.reload();
      });
    }
  }
  goBackClose() {

    let strBack: string;

    if (this.backToStoreId == null) {
      window.close();
    } else {
      let vals = this.backToStoreId.split(",");

      if (vals.length == 1) {
        strBack = vals[0];
        this.backToStoreId = null;
      } else {
        if (vals.length == 2) {
          this.backToStoreId = vals[0];
          strBack = vals[1];
        } else if (vals.length >= 3) {
          this.backToStoreId = vals[0] + "," + vals[1];
          strBack = vals[2];
        }
      }

      this.router.navigate(['reports/zoneProductionOrders'], { queryParams: { token: this.token, selectedStore: strBack, selectedYear: this.selectedYearVO.year, status: this.selectedStatus.fieldVal, backToStoreId: this.backToStoreId } }).then(() => {
        window.location.reload();
      });

    }
  }
}
